import { render, staticRenderFns } from "./signUpChinese.vue?vue&type=template&id=55c80d36&scoped=true"
import script from "./signUpChinese.vue?vue&type=script&lang=js"
export * from "./signUpChinese.vue?vue&type=script&lang=js"
import style0 from "./signUpChinese.vue?vue&type=style&index=0&id=55c80d36&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55c80d36",
  null
  
)

export default component.exports